import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Row from '../components/Row';
import MovieModal from '../components/MovieModal';
import SponsorshipBanner from '../components/SponsorshipBanner';
import { endpoints } from '../utils/tmdb';

const Kids = () => {
  const [selected, setSelected] = useState(null);

  return (
    <div className="bg-[#141414] min-h-screen text-white">
      <Navbar />
      <Hero onMoreInfo={setSelected} fetchPath={endpoints.animationMovies} />
      <div className="-mt-24 relative z-10 pb-16">
        <SponsorshipBanner placement="kids_top" />
        <Row title="Family Favorites" fetchPath={endpoints.familyMovies} onSelect={setSelected} />
        <Row title="Animated Adventures" fetchPath={endpoints.animationMovies} onSelect={setSelected} />
        <Row title="Kids TV Shows" fetchPath={endpoints.kidsShows} onSelect={setSelected} />
        <Row title="Popular for Kids" fetchPath={endpoints.kidsFamily} isLarge onSelect={setSelected} />
      </div>

      <MovieModal item={selected} onClose={() => setSelected(null)} />
    </div>
  );
};

export default Kids;
